import { InvoiceFile } from './invoice-file.model';

export class InvoiceHeader {
  comments: string;
  customerContact: string;
  customerEmail: string;
  dates: {
    invoiceDate?: string;
    operationDate: string;
  };
  description?: string;
  documentType: string;
  files: InvoiceFile;
  incoterm?: string;
  referenceNumber?: string;

  constructor(values= {}) {
    Object.assign(this, values);
    this.files = this.files ? new InvoiceFile(this.files) : new InvoiceFile();
  }
}
